import { XCircle, ArrowUpRight } from "lucide-react";
import BrandMark from "@/components/landing/BrandMark";

export default function PaymentCancel() {
  return (
    <main className="min-h-screen bg-[#07182D] text-white grid place-items-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 grid-lines opacity-20" aria-hidden />
      <div className="absolute w-[440px] h-[440px] rounded-full bg-[#D4A017]/10 blur-[130px]" aria-hidden />

      <div className="relative z-10 max-w-lg w-full text-center border-2 border-white/10 bg-[#0B1F3A] p-10" data-testid="payment-cancel">
        <div className="flex justify-center mb-6">
          <BrandMark size={56} />
        </div>
        <XCircle size={44} className="text-[#DC2626] mx-auto" />
        <h1 className="font-display uppercase text-4xl mt-5 leading-none">
          Checkout cancelled
        </h1>
        <p className="text-white/75 text-base mt-4 leading-relaxed">
          No worries — you haven&rsquo;t been charged. Your 14-day free trial is still
          waiting whenever you&rsquo;re ready.
        </p>
        <a
          href="/#pricing"
          data-testid="cancel-back-pricing"
          className="btn-brutal mt-8 inline-flex items-center justify-center gap-2 bg-[#D4A017] text-[#07182D] font-display uppercase tracking-wide px-7 py-4 border-2 border-[#D4A017] shadow-hard-sm"
        >
          Back to pricing
          <ArrowUpRight size={18} strokeWidth={2.5} />
        </a>
      </div>
    </main>
  );
}
